import React from 'react'
import styled from 'styled-components'
import APIList, { APIListWrapper } from '../components/APIList'
import DownLoadIcon from '../asset/DownLoadIcon'
import DeleteIcon from '../asset/DeleteIcon'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  overflow: hidden;
`

const Header = styled.div`
  padding: 16px 24px 16px 24px;
  background: #373a40;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

const Title = styled.div`
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  color: #ffffff;
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 24px;
  overflow-y: auto;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const GraphBox = styled.div`
  height: 240px;
  padding: 12px;
  border-radius: 4px;
  gap: 12px;
`

const Bottom = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
`

const ButtonBox = styled.div`
  display: flex;
  padding: 8px;
  border-radius: 4px;
  gap: 4px;
  align-items: center;
  cursor: pointer;
`

const ButtonText = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
`

export const DataMonthlySMP = () => {
  return (
    <>
      <APIListWrapper>
        <APIList noApi />
      </APIListWrapper>
      <ContentWrapper>
        <Header>
          <Title>월가중 SMP</Title>
        </Header>
        <BodyWrapper>
          <Body>
            <GraphBox></GraphBox>
            <Bottom>
              <ButtonBox>
                <DownLoadIcon />
                <ButtonText>다운로드</ButtonText>
              </ButtonBox>
              <ButtonBox>
                <DeleteIcon />
                <ButtonText>삭제</ButtonText>
              </ButtonBox>
            </Bottom>
          </Body>
        </BodyWrapper>
      </ContentWrapper>
    </>
  )
}
